import LayoutComponent from "../components/LayoutComponent";
import React, {useEffect, useState} from "react";
import {useApi} from "../provider/ApiProvider";
import {Badge, Button, Popconfirm} from "antd";
import {UndoOutlined} from "@ant-design/icons";
import TableComponent from "../components/TableComponent";


export default function UserRestartPage() {
    const columns = [

        {
            title: 'Adı',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Soyadı',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'TC',
            dataIndex: 'identityNumber',
            key: 'identityNumber',

        },

        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            responsive: ["lg"]
        },

        {
            title: 'Firma / Şube',
            render: (record) => record.Company.name
        },

        {
            title: 'Durumu',
            responsive: ["lg"],
            render: (record) => record.isActive ? <Badge status="success" text={"Aktif"} /> : <Badge status="error" text={"Pasif"} />

        },

        {
            title: 'Sıfırla',
            render: (record) => (
                <div>
                    <Popconfirm
                        title="Kullanıcı bilgileri sıfırlanacaktır. Emin misiniz?"
                        onConfirm={() => {reset(record.id)}}
                        onCancel={() => {
                            return;
                        }}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button  danger>
                            <UndoOutlined/>
                        </Button>
                    </Popconfirm>
                </div>
            )
        }

    ];

    const {api} = useApi();
    const [users, setUsers] = useState({totalCount: 0, items: []});

    useEffect(() => {
        load({search: "", skip: 0, max: 10});

    }, [])

    async function load(filter){
        await api.get('/userRouter/user/all', filter).then(resp => {
            setUsers({totalCount: resp.totalCount, items:resp.data});
        })
    }

    async function reset(userId){

        await api.put('/userRouter/user/reset/' + userId,).then(resp => {
           load()
        })
    }
    async function onSearch(value){
        let filter = {
            search: value
        }
        await api.get('/userRouter/user/all', filter).then(resp => {
            setUsers({totalCount: resp.totalCount, items:resp.data});
        })
    }
    function tableChange(filter){
        let newFilter = {
            skip: (filter.page - 1) * filter.perPage,
            max: filter.perPage
        }
        load(newFilter);
    }

    return (
        <LayoutComponent title={"Kullanıcı Sıfırla"}  links={
            [
                {
                    title: 'Kullanıcı Sıfırla',
                    url: '/'
                },

            ]}
        >
            <TableComponent
                columns={columns}
                data={users}

                search={true}
                onSearch={onSearch}
                onChange={tableChange}
            />
        </LayoutComponent>
    )
}
